import React from 'react';
import { Quote } from 'lucide-react';
import { clients } from '../mockData';

const Clients = () => {
  return (
    <section id="clientes" className="section clients-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Nuestros Clientes</h2>
          <p className="section-description">
            La confianza de empresas líderes nos respalda
          </p>
        </div>

        <div className="clients-grid">
          {clients.map((client) => (
            <div key={client.id} className="client-card">
              <div className="client-logo-container">
                <img src={client.logo} alt={client.name} className="client-logo" />
              </div>
              <div className="client-content">
                <Quote className="client-quote-icon" size={24} />
                <p className="client-testimonial">{client.testimonial}</p>
                <h4 className="client-name">{client.name}</h4>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;
